<template>
  <v-container fluid>
    <v-card elevation="5">
      <v-card-text>
        <v-row>
          <v-col cols="6" md="6" sm="12">
            <v-card flat>
              <v-card-title>SasaPay Simulations</v-card-title>
              <v-card-text>
                <v-form v-model="isValid" ref="simulationForm" @submit.prevent="simulate">
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-select
                          label="Select API"
                          outlined
                          v-model="formData.apiId"
                          :rules="[rules.required]"
                          :items="apis"
                          :item-text="item=>item.label"
                          :item-value="item=>item.value"
                      />
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-select
                          label="Select Your App"
                          outlined
                          v-model="formData.applicationId"
                          :rules="[rules.required]"
                          :items="applications"
                          :item-text="item=>item.application.name"
                          :item-value="item=>item.application.id"
                          @change="onApplicationChange"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="mt-n4">
                      <v-text-field
                          label="Client ID"
                          outlined
                          v-model="formData.clientId"
                          readonly
                      />
                    </v-col>
                    <v-col cols="12" class="mt-n4">
                      <v-text-field
                          label="Client Secret"
                          outlined
                          v-model="formData.clientSecret"
                          readonly
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="mt-n4">
                      <v-text-field
                          label="Basic Authorization"
                          outlined
                          v-model="formData.authorization"
                          readonly
                      />
                    </v-col>
                    <v-col cols="12" class="mt-n4">
                      <v-text-field
                          label="Grant Type"
                          outlined
                          readonly
                          v-model="formData.grant_type"
                      />
                    </v-col>
                  </v-row>
                  <v-btn type="submit" color="primary" block>Let's Go</v-btn>
                </v-form>
              </v-card-text>
            </v-card>
          </v-col>
          <v-divider vertical/>
          <v-col cols="6" md="6" sm="12">
            <v-card flat>
              <v-card-title>SasaPay Console</v-card-title>
              <v-card-text>
                <code-editor
                    :read_only="true"
                    theme="dark"
                    v-model="code"
                    @lang="changeLanguage"
                    :wrap_code="true"
                    :language_selector="true"
                    class="github_dark"
                    :copy_code="true"
                    font_size="12px"
                    height="50%"
                    width="100%"
                    :languages="languages"
                ></code-editor>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import helpers from "../../../../shared/utilities/helpers";
import {getAuthResponse, getCodeSnippets} from "../../../../shared/snippets/JavaScript/auth";

export default {
  name:"Simulator",
  beforeRouteEnter(to,from,next){
    next(v=>{
      v.$store.dispatch("Dashboard/getApplications",{isLive:false})
    })
  },
  data: () => ({
    formData: {
      applicationId:"",
      apiId:"",
      clientId:"",
      clientSecret:"",
      grant_type:"client_credentials",
      authorization:"",
    },
    selectedApplication:{},
    isValid:false,
    submitting:false,
    //
    apis:[
      {
        label:"Authentication",
        value:"authentication"
      },
      /*{
        label:"Register Callback URL",
        value:"registerCallbackURL"
      }*/
    ],
    rules: {
      required: [
        value => !!value || 'This field is required',
      ],
    },

  }),
  computed:{
    applications(){
      return this.$store.getters['Dashboard/DashboardGetter']("applications")
    }
  },
  methods: {
    async simulate() {
      this.submitting = true;
      if (!this.isValid) {
        this.$refs.simulationForm.validate()
        this.submitting = false;
      } else {
        await this.$store.dispatch('Simulator/generateToken', {...this.formData})
      }
    },
    onApplicationChange(id) {
      let app=this.applications.filter(el=>el.application.id===id)
      this.selectedApplication=app.shift();
      //set values
      this.formData.clientId=this.selectedApplication.application.client_id
      this.formData.clientSecret=this.selectedApplication.application.client_secret
      //
      this.formData.authorization=helpers.generateBearerToken(this.selectedApplication.application)
    },
    importAuthSnippets(lang){
      this.code=getCodeSnippets(lang)
    },
    importAuthResponse(){
      this.response=getAuthResponse()
    },
    //
    changeLanguage(val) {
      this.importAuthSnippets(val)
    }
  },
}
</script>